module.exports = __webpack_public_path__ + "img/pauli-y-root-dagger-19.cc27f408.svg";